import React from 'react';
import Head from 'next/head';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import getConfig from 'next/config';
import get from 'lodash.get';

import { curation as curationPropType } from 'lib/CustomPropTypes';
import { shareImage } from 'lib/social';
import { TVE_CANONICAL_ROUTE } from 'lib/tve';

const mapStateToProps = ({ front, router, shared }) => ({
  curation: front.curation,
  domain: router.domain,
  path: router.path,
  vertical: shared.vertical,
});

function Meta({
  curation, domain, path, vertical,
}) {
  // TODO, override these values with vertical or content specific values
  const description = 'Live stream MSNBC, join the MSNBC community and watch full episodes of your favorite MSNBC shows, including Rachel Maddow, Morning Joe and more.';
  const title = 'MSNBC Live: Stream the latest TV shows';
  const url = `https://www.${domain}${path}`;

  // Image from curation
  const { socialImage: { url: image } = {} } = curation || {};
  const imageUrl = image && image.primary;
  const canonicalUrl = `https://www.${domain}/${TVE_CANONICAL_ROUTE}`;

  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />

      <link rel="canonical" href={canonicalUrl} />

      <meta name="thumbnail" content={shareImage(imageUrl, vertical)} />

      <meta property="og:description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={shareImage(imageUrl, vertical, 'og')} />
      <meta property="og:image:secure_url" content={shareImage(imageUrl, vertical, 'og')} />
      <meta property="og:image:type" content={get(image, 'encodingFormat', 'image/gif')} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      <script
        data-rh="true"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
          __html: JSON.stringify({
            '@context': {
              '@vocab': 'http://schema.org',
              pageType: {
                '@id': 'Text',
                '@type': '@id',
              },
              vertical: {
                '@id': 'Text',
                '@type': '@id',
              },
              subVertical: {
                '@id': 'Text',
                '@type': '@id',
              },
              section: {
                '@id': 'Text',
                '@type': '@id',
              },
              subSection: {
                '@id': 'Text',
                '@type': '@id',
              },
              packageId: {
                '@id': 'Text',
                '@type': '@id',
              },
              sponsor: {
                '@id': 'Text',
                '@type': '@id',
              },
              appVersion: {
                '@id': 'Text',
                '@type': '@id',
              },
            },
            '@type': 'Dataset',
            name: 'additionalTaxonomy',
            description: 'This is additional taxonomy that helps us with analytics',
            url: canonicalUrl,
            pageType: 'SectionFront',
            vertical,
            subVertical: '',
            section: TVE_CANONICAL_ROUTE,
            subSection: '',
            packageId: '',
            sponsor: '',
            appVersion: get(getConfig(), ['publicRuntimeConfig', 'appVersion'], ''),
          }),
        }}
      />
    </Head>
  );
}

Meta.propTypes = {
  curation: curationPropType.isRequired,
  domain: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  vertical: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(Meta);
